module.exports = __webpack_public_path__ + "static/media/createUserTam.ee3460b2.jpg";